import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip, { type TooltipProps } from 'react-bootstrap/Tooltip';

function HTooltip({
  title,
  id,
  children,
}: {
  title?: string;
  id?: string;
  children: any;
}) {
  if (!title) {
    return children;
  }
  const renderTooltip = (props: TooltipProps) => (
    <Tooltip id={id ?? 'tooltip'} {...props}>
      {title}
    </Tooltip>
  );

  return (
    <OverlayTrigger overlay={renderTooltip} delay={{ show: 250, hide: 400 }}>
      {children}
    </OverlayTrigger>
  );
}

export default HTooltip;
